<template>
  <div :class="['widget', {'border-error': error}]">

    <v-container>
      <v-layout
        align-center
        justify-space-between>
        <span
          id="title"
          class="subheading">
          Access notes
        </span>
        <v-btn
          id="button"
          class="ma-0"
          icon
          small
          @click="dialog = true">
          <v-icon small>edit</v-icon>
        </v-btn>
      </v-layout>

      <template v-if="loading">
        <v-layout
          align-center
          justify-center
          fill-height>
          <v-progress-circular
            size="50"
            indeterminate/>
        </v-layout>
      </template>

      <template v-else>
        <v-container style="padding: 12px 24px 0 24px;">
          <v-layout
            v-if="site.access"
            class="caption">
            <v-flex>
              <div>{{ site.access }}</div>
            </v-flex>
          </v-layout>
          <v-layout
            v-else-if="error === 0"
            class="caption">
            <v-flex grow>
              <div style="color: grey;">No notes.</div>
            </v-flex>
          </v-layout>
          <v-layout
            v-else
            class="caption">
            <v-flex grow>
              <div style="color: orange;">Error {{ error }}.</div>
            </v-flex>
          </v-layout>
        </v-container>
      </template>
    </v-container>

    <v-dialog
      v-model="dialog"
      persistent
      max-width="70em">
      <v-card>
        <v-card-text>
          <v-form v-model="valid">
            <v-container grid-list-md>
              <v-layout>
                <v-flex>
                  <v-textarea
                    v-model="edited.access"
                    auto-grow
                    label="Access notes"
                    outline
                    rows="1"/>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            :disabled="posting"
            flat
            @click="dialog = false">
            Cancel
          </v-btn>
          <v-btn
            :disabled="posting || !valid"
            flat
            @click="save">
            <v-progress-circular
              v-if="posting"
              indeterminate/>
            <span v-else>Save</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
export default {
  name: "",
  data () {
    return {
      dialog: false,
      edited: {},
      error: 0,
      loading: false,
      posting: false,
      site: {},
      valid: false
    };
  },
  watch: {
    dialog (newValue) {
      if (newValue === true) {
        this.edited = Object.assign({}, this.site);
      }
    }
  },
  created () {
    this.load();
  },
  methods: {
    load (config) {
      this.loading = true;
      this.$http.
        get(`/api/sites/${this.$route.params.id}/access`, config).
        then((r) => this.site = Object.assign({}, r.data)).
        catch((err) => this.error = err.response.status).
        finally(() => this.loading = false);
    },
    save () {
      this.posting = true;
      this.$http.
        put(`/api/sites/${this.$route.params.id}/access`, this.edited).
        then(() => {
          this.load({ headers: { "Cache-Control": "no-cache" } });
          this.dialog = false;
        }).
        finally(() => this.posting = false);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Site/AccessNotes.vue